import {
  MixedSchema,
  isMixedSchema,
  isRawInlineNodes,
  type RawInlineNodes,
} from '@principle-theorem/editor';
import {
  TypeGuard,
  WithRef,
  isINamedDocument,
  isObject,
  isWithRef,
  type INamedDocument,
} from '@principle-theorem/shared';
import { isBoolean } from 'lodash';
import {
  IAutomation,
  isAutomation,
  isAutomationConfiguration,
  type IAutomationConfiguration,
  type IAutomationResource,
} from '../automation/automation';
import { isAutomationTiming } from '../automation/automation-timing';
import { type IStaffer } from '../staffer/staffer';
import { type ITeam } from '../team/team';
import { TemplateScope } from '../templating/template-scope';
import { TaskPriority } from './task';

export interface IGeneratedTaskConfiguration
  extends IAutomationConfiguration,
    IGeneratedTask {}

export function getGeneratedTaskFromConfiguration(
  config: IGeneratedTaskConfiguration
): IGeneratedTask {
  return {
    title: config.title,
    assignee: config.assignee,
    priority: config.priority,
    comment: config.comment,
    isForTeam: config.isForTeam,
    timing: config.timing,
    requiredConditions: config.requiredConditions,
    scope: config.scope,
  };
}

export interface IGeneratedTask extends IAutomationResource {
  title: RawInlineNodes;
  assignee?: INamedDocument<IStaffer | ITeam>;
  priority: TaskPriority;
  comment: MixedSchema;
  isForTeam: boolean;
  // TODO: Make required once the custom template is implemented
  scope?: TemplateScope;
}

export const isGeneratedTask = TypeGuard.interface<IGeneratedTask>({
  title: TypeGuard.merge(isObject, isRawInlineNodes),
  comment: isMixedSchema,
  timing: isAutomationTiming,
  scope: TypeGuard.nilOr(TypeGuard.enumValue(TemplateScope)),
  assignee: TypeGuard.nilOr(isINamedDocument),
  priority: TypeGuard.enumValue(TaskPriority),
  isForTeam: isBoolean,
  requiredConditions: TypeGuard.nilOr(isObject),
});

export function isTaskAutomation(
  automation: unknown
): automation is WithRef<IAutomation<IGeneratedTask>> {
  return (
    isWithRef(automation) &&
    isAutomation<IGeneratedTask>(automation, isGeneratedTask)
  );
}

export function isGeneratedTaskConfiguration(
  data: unknown
): data is IGeneratedTaskConfiguration {
  return isGeneratedTask(data) && isAutomationConfiguration(data);
}
